import React from "react";
import { withStyles } from "@material-ui/core";
import { useTranslations } from "adapters/i18n";

const MovementSituationCards = ({
  classes,
  countOrigin,
  countDestiny,
  originCategoryName,
  originPastureName,
  destinyCategoryName,
  destinyPastureName,
  cardTitle,
}) => {
  const { t } = useTranslations();
  return (
    <div
      className={classes.situationCardsContainer}
      data-testid="MovementSituationCards"
    >
      <div className={classes.titleCurrentSituation}>
        <h1
          data-testid="TestTitleCurrentSituation"
          className={classes.currentSituationText}
        >
          {cardTitle}
        </h1>
      </div>
      <div className={classes.currentSituationContainer}>
        <div className={classes.container}>
          <h2 className={classes.title} data-testid="TestTitleOriginPasture">
            {t("pendency:origin-pasture")}
          </h2>
          <table className={classes.currentSituationTable}>
            <thead>
              <tr>
                <th className={classes.currentSituationTh}>
                  {t("pendency:name-origin-pasture")}
                </th>
                <th className={classes.currentSituationTh}>
                  {t("pendency:category")}
                </th>
                <th
                  className={classes.currentSituationTh}
                  data-testid="TestNumberOriginPastureTitle"
                >
                  {t("pendency:number-animals-in-pasture")}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={classes.currentSituationTb}>
                  {originPastureName}
                </td>
                <td className={classes.currentSituationTb}>
                  {originCategoryName}
                </td>
                <td
                  className={classes.currentSituationTb}
                  data-testid="TestNumberOriginPasture"
                >
                  {countOrigin !== null ? `${countOrigin} ${t("movements:animal.plural")}` : ""}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={classes.container}>
          <h2 className={classes.title} data-testid="TestTitleDestinyPasture">
            {t("pendency:destination-pasture")}
          </h2>
          <table className={classes.currentSituationTable}>
            <thead>
              <tr>
                <th className={classes.currentSituationTh}>
                  {t("pendency:name-destination-pasture")}
                </th>
                <th className={classes.currentSituationTh}>{t("pendency:category")}</th>
                <th
                  className={classes.currentSituationTh}
                  data-testid="TestNumberDestinyPastureTitle"
                >
                  {t("pendency:number-animals-in-pasture")}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={classes.currentSituationTb}>
                  {destinyPastureName}
                </td>
                <td className={classes.currentSituationTb}>
                  {destinyCategoryName}
                </td>
                <td
                  className={classes.currentSituationTb}
                  data-testid="TestNumberDestinyPasture"
                >
                  {countDestiny !== null ? `${countDestiny} ${t("movements:animal.plural")}` : ""}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const styles = (theme) => ({
  titleCurrentSituation: {
    display: "flex",
    alignItems: "center",
    marginTop: "8px",
  },
  currentSituationText: {
    fontFamily: "Roboto",
    fontSize: "20px",
    fontWeight: "bold",
    color: "#444",
  },
  currentSituationContainer: {
    display: "flex",
    justifyContent: "space-between",
    maxWidth: "100%",
  },
  container: {
    width: "48%",
    minHeight: "136px",
    borderRadius: "8px",
    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
    border: "1px solid #e5e5ea",
    backgroundColor: "#fff",
  },
  title: {
    padding: "15px 0px 16px 32px",
    margin: "0px",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontWeight: "800",
    letterSpacing: "0.5px",
    color: "#307297",
    textTransform: "uppercase",
  },
  currentSituationTable: {
    width: "100%",
    borderCollapse: "collapse",
    textAlign: "left",
    fontFamily: "Roboto",
  },
  currentSituationTh: {
    padding: "10px",
    backgroundColor: theme.palette.disabled.light,
    border: "1px solid #E5E5EA",
    borderLeft: "1px solid #E5E5EA",
    fontWeight: "400",
    fontSize: "12px",
    letterSpacing: "0.75px",
    color: "#8E8E93",
    textTransform: "uppercase",
  },
  currentSituationTb: {
    padding: "10px",
    fontWeight: "400",
    fontSize: "24px",
    letterSpacing: "-0.05px",
    color: theme.palette.default1.main,
    borderLeft: "1px solid #E5E5EA",
  },
});
export default withStyles(styles)(MovementSituationCards);
